import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { getStoredValue } from "../storage";
import { ENVIROMENT, DEV_NEW_AUTH_CONSOLE, PROD_NEW_AUTH_CONSOLE_FULL } from "../utilities";

export const AuthenticationState = {
  Authenticated: "authenticated",
  Unauthenticated: "unauthenticated",
  InProgress: "loading",
};

const OktaIDP = ({ provider, children }) => {
  // Intenta restaurar de sessionStorage para “perdurar” entre montajes
  const [authState, setAuthState] = useState(
    () => sessionStorage.getItem("authState") || AuthenticationState.InProgress
  );
  const [accountInfo, setAccountInfo] = useState(() => {
    const raw = sessionStorage.getItem("accountInfo");
    return raw ? JSON.parse(raw) : null;
  });

  // Evita dobles llamadas en el mismo montaje
  const fetchedRef = useRef(false);

  useEffect(() => {
    const fetchUser = async () => {
      if (fetchedRef.current) return;
      fetchedRef.current = true;

      try {
        const token = await getStoredValue("oktatoken");
        if (!token) {
          setAuthState(AuthenticationState.Unauthenticated);
          sessionStorage.setItem("authState", AuthenticationState.Unauthenticated);
          return;
        }

        // Si ya tenemos datos restaurados, no vuelvas a pedir
        if (authState === AuthenticationState.Authenticated && accountInfo) return;

        const res = await axios.get(
          (ENVIROMENT === "dev" ? DEV_NEW_AUTH_CONSOLE : PROD_NEW_AUTH_CONSOLE_FULL) +
            "okta/whoami",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            params: { source: "inventario" },
          }
        );

        if (res.status === 200) {
          const info = { account: res.data };
          info.account.name = res.data.displayName;
          setAccountInfo(info);
          setAuthState(AuthenticationState.Authenticated);
          sessionStorage.setItem("authState", AuthenticationState.Authenticated);
          sessionStorage.setItem("accountInfo", JSON.stringify(info));
        } else {
          setAuthState(AuthenticationState.Unauthenticated);
          sessionStorage.setItem("authState", AuthenticationState.Unauthenticated);
        }
      } catch (error) {
        console.error("Error autenticando usuario:", error);
        setAuthState(AuthenticationState.Unauthenticated);
        sessionStorage.setItem("authState", AuthenticationState.Unauthenticated);
      }
    };

    fetchUser();
    // Nota: no metemos authState en deps para no re-disparar con cierres antiguos
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children({
    authenticationState: authState,
    accountInfo,
  });
};

export { OktaIDP };
